import { Chip } from '@/global/components/Chip'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { match } from 'ts-pattern'

export default function OperacaoChip({ value }: GridCellParams) {
    return (
        <Chip
            label={value}
            className="w-full font-bold"
            color={match(value)
                .with('READ', 'LOGIN', () => undefined)
                .with('INSERT', () => 'success' as const)
                .with('UPDATE', () => 'info' as const)
                .with('DELETE', () => 'warning' as const)
                .otherwise(() => 'error' as const)}
        />
    )
}
